"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnitUtil = void 0;
var getUnitUtil = function (options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var metricText = (_a = document.querySelector('.dis-content-visible select[name="metric"] option:checked')) === null || _a === void 0 ? void 0 : _a.textContent;
    var unitText = (_b = document
        .querySelector('.dis-content-visible input[name="unit"]:checked')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-short-name');
    return metricText && unitText ? metricText + " " + (options.omitUnit ? '' : "| " + unitText) : null;
};
exports.getUnitUtil = getUnitUtil;
